import api from './api';
import Step from './step';

export interface IngredientInterface {
    id: number;
    name: string;
    internal_name: string;
    in_stock: boolean;
    quantifiable: boolean;
    time_start: Date | string | null;
    time_end: Date | string | null;
    quantity?: number;
    price?: number;
    is_required: boolean;
    updated_at?: string;
}

export default class Ingredient implements IngredientInterface {
    id: number;
    name: string;
    internal_name: string;
    in_stock: boolean;
    quantifiable: boolean;
    time_start!: Date;
    time_end!: Date;
    quantity?: number;
    price: number;
    is_required: boolean;
    updated_at?: string;

    constructor(ingredient: IngredientInterface) {
        this.id = ingredient.id;
        this.name = ingredient.name;
        this.internal_name = ingredient.internal_name;
        this.in_stock = ingredient.in_stock ? true : false;
        this.quantifiable = ingredient.quantifiable;
        this.price = ingredient.price || 0;
        this.is_required = ingredient.is_required;
        if (ingredient.time_start) {
            this.time_start = new Date(ingredient.time_start);
        }
        if (ingredient.time_end) {
            this.time_end = new Date(ingredient.time_end);
        }
        if (ingredient.quantity !== undefined) {
            this.quantity = ingredient.quantity;
        }
        if (ingredient.updated_at) {
            this.updated_at = ingredient.updated_at;
        }
    }

    static async all(): Promise<Ingredient[]> {
        const response = await api.get<IngredientInterface[]>({ name: 'ingredient.index' });
        if (response.success) {
            return Ingredient.createBatch(<IngredientInterface[]>response.content);
        }
        return [];
    }

    static async find(id: number): Promise<Ingredient | null> {
        const response = await api.get<IngredientInterface>({ name: 'ingredient.show', parameters: { id } });
        if (response.success) {
            return new Ingredient(response.content as IngredientInterface);
        }
        return null;
    }

    public async update(): Promise<boolean> {
        const response = await api.post<null>(
            { name: 'ingredient.update', parameters: { id: this.id } },
            {
                id: this.id,
                name: this.name,
                in_stock: this.in_stock,
                quantifiable: this.quantifiable,
                time_start: this.time_start,
                time_end: this.time_end,
                quantity: this.quantity,
            }
        );
        return response.success;
    }

    public priceForStep(step: Step) {
        const stepIng = step.ingredients.find((ingredient) => ingredient.id === this.id);
        if (stepIng) {
            return stepIng.price;
        }
        return 0;
    }

    public static createBatch(ingredients: IngredientInterface[]): Ingredient[] {
        let ingredientInstances = [];
        for (let index = 0; index < ingredients.length; index++) {
            ingredientInstances.push(new Ingredient(ingredients[index]));
        }
        return ingredientInstances;
    }
}
